import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import { deleteEarnedLeave } from "./store/earnedLeaveSlice";
import AddEarnedLeave from "./AddEarnedLeave";

const EarnedLeaveDataTable = ({ data, loading }) => {
  const [selectedId, setSelectedId] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();

  const { successMessage, error } = useSelector(
    (state) => state.earnedLeaveData
  );
  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
    }
    if (error) {
      toast.error(error);
    }
  }, [successMessage, error]);

  const handleDelete = (earnedLeaveId) => {
    dispatch(deleteEarnedLeave(earnedLeaveId));
    setDeleteModalOpen(false);
  };

  const columns = [
    // {
    //   title: "Name",
    //   dataIndex: `${"first_name"}`,
    //   render: (text, record) => (
    //     <div className="table-avatar">
    //       {/* <Link to="/profile" className="avatar">
    //         <img alt="" src={record.image} />
    //       </Link> */}
    //       <Link to="/profile">{text}</Link>
    //     </div>
    //   ),
    // },
    // {
    //   title: "Employee ID",
    //   dataIndex: "employee_id",
    // },
    {
      title: "Employee Name",
      dataIndex: "employee",
      render: (employee) => `${employee.first_name} ${employee.last_name}`,
    },
    {
      title: "Employee Code",
      dataIndex: "employee_code",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },

    {
      title: "Month",
      dataIndex: "month",
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   render: (text) => (
    //     <span className={"badge bg-inverse-success"}>{text}</span>
    //   ),
    // },
    // {
    //   title: "Joining Date",
    //   dataIndex: "date_of_joining",
    // },
    // {
    //   title: "Action",
    //   render: (text, record) => (
    //     <div className="dropdown dropdown-action text-start">
    //       <Link
    //         to="#"
    //         className="action-icon dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <i className="material-icons">more_vert</i>
    //       </Link>
    //       <div className="dropdown-menu dropdown-menu-right">
    //         {/* <Link
    //           className="dropdown-item"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#edit_user"
    //         >
    //           <i className="fa fa-pencil m-r-5" /> Edit
    //         </Link> */}
    //         {/* <Link
    //           className="dropdown-item"
    //           to="#"
    //           onClick={() => {
    //             setSelectedEmployeeId(record.id);
    //             setDeleteModalOpen(true);
    //           }}
    //         >
    //           <i className="fa fa-trash m-r-5" /> Delete
    //         </Link> */}
    //       </div>
    //     </div>
    //   ),
    // },
  ];

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="table-responsive">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            rowKey="id"
            pagination={{ pageSize: 10 }}
          />
          {isModalOpen && (
            <AddEarnedLeave
              show={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              userId={selectedId}
            />
          )}

          {deleteModalOpen && (
            <DeleteModal
              onConfirm={() => handleDelete(selectedId)}
              onCancel={() => setDeleteModalOpen(false)}
              Name="Earned Leave"
            />
          )}
        </div>
      </div>
    </div>
  );
};



export default EarnedLeaveDataTable
